/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';

import { WysiwygStyleWrapper } from '@powdr/components';

import { TrafficSign } from './components';
import { StyledDorTrafficSigns, Title } from './styles';

export const DorTrafficSigns = ({
  title,
  relationships,
  parentColorProfile,
}) => {
  const { trafficSigns = [] } = relationships;

  return (
    <StyledDorTrafficSigns>
      <WysiwygStyleWrapper colorProfile={parentColorProfile}>
        {(title) && <Title>{title}</Title>}
        {trafficSigns?.map((trafficSign) => (
          <TrafficSign
            {...trafficSign}
          />
        ))}
      </WysiwygStyleWrapper>
    </StyledDorTrafficSigns>
  );
};

DorTrafficSigns.propTypes = {
  title: PropTypes.string,
  relationships: PropTypes.shape({
    trafficSigns: PropTypes.shape({
      trafficSignTitle: PropTypes.string,
      defaultCopy: PropTypes.shape({
        value: PropTypes.string,
      }),
      trafficSign: PropTypes.string,
    }),
  }).isRequired,
  parentColorProfile: PropTypes.string,
};
